import { CopyPasteFormat, ValidationIssue } from 'api'
import { CopyPasteFormatHelper } from 'model'
import React from 'react'
import { Field } from 'view/components/inputs'
import { Selectbox } from 'view/components/options'

interface CopyPasteFormatSelectboxProps {
  value: CopyPasteFormat
  className?: string
  readOnly?: boolean
  disabled?: boolean
  onUpdate: (value: CopyPasteFormat) => void
  validationIssues?: ValidationIssue[]
  dataTestId?: string
}

const optionKeys = Object.values(CopyPasteFormat)

export const CopyPasteFormatSelectbox = React.forwardRef(
  ({ className, disabled, onUpdate, readOnly, validationIssues, value }: CopyPasteFormatSelectboxProps, ref: React.Ref<Selectbox>) => {
    return (
      <Selectbox
        ref={ref}
        className={className}
        optionKeys={optionKeys}
        getOptionText={CopyPasteFormatHelper.getName}
        value={value}
        readOnly={readOnly}
        disabled={disabled}
        onUpdate={onUpdate as any}
        validationIssues={validationIssues ?? []}
      />
    )
  }
)

export const CopyPasteFormatSelectboxField = Field(CopyPasteFormatSelectbox)
